import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_REFERRALS_GET_PARTNER_EARNINGS } from 'api/utilityActionTypes';

export default async function getPartnerEarnings(
  { state, utilityApiClient },
  { utilityPartnerId, forceRefresh = false },
) {
  typeCheck('utilityPartnerId::Maybe PositiveNumber', utilityPartnerId);

  const currentStatePath = ['utilityPartners', 'referralEarnings', utilityPartnerId];

  if (state.get(currentStatePath) && !forceRefresh) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_REFERRALS_GET_PARTNER_EARNINGS,
    state: state,
    payload: {
      utilityPartnerId: utilityPartnerId,
    },
    onSuccess(partnerEarnings) {
      if (partnerEarnings) {
        state.set(currentStatePath, partnerEarnings);
      }
    },
  });
}
